import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  getUserExternalBankAccounts,
  GetUserExternalBankAccountOptions,
  getUserPaymentMethods,
  GetUserPaymentMethodOptions,
  HighnoteExternalBankAccountsResponse,
  HighnotePaymentMethodsResponse,
} from 'api/payments'

export function useUserPaymentMethods(
  filters: GetUserPaymentMethodOptions,
  options?: Pick<
    Parameters<
      typeof useQuery<
        HighnotePaymentMethodsResponse,
        Error,
        HighnotePaymentMethodsResponse,
        string[]
      >
    >[0],
    'retry' | 'initialData' | 'enabled'
  >
): UseQueryResult<HighnotePaymentMethodsResponse> {
  return useQuery({
    queryKey: ['userPaymentMethods', filters.userId.toString()],
    queryFn: async () => getUserPaymentMethods(filters),
    retry: false,
    ...options,
  })
}

export function useUserExternalBankAccounts(
  filters: GetUserExternalBankAccountOptions,
  options?: Pick<
    Parameters<
      typeof useQuery<
        HighnoteExternalBankAccountsResponse,
        Error,
        HighnoteExternalBankAccountsResponse,
        string[]
      >
    >[0],
    'retry' | 'initialData' | 'enabled'
  >
): UseQueryResult<HighnoteExternalBankAccountsResponse> {
  return useQuery({
    queryKey: ['userExternalBankAccounts', filters.userId.toString()],
    queryFn: async () => getUserExternalBankAccounts(filters),
    retry: false,
    ...options,
  })
}
